import { Routes, Route } from 'react-router-dom';
import TaskList from './list';
import ViewTask from './view/ViewTask';
import ViewQuestions from './view/ViewQuestions';
import PrintView from './print';



const Task = () => {
  return (
    <Routes>
      <Route path="/" element={<TaskList />} />
      {/* <Route path="/add" element={<AddQSet />} /> */}
      {/*<Route path="/edit/:id" element={<EditQSet />} />*/}
      <Route path="/view/:id" element={<ViewTask />} />
      {/* <Route path='/solution/:id' element={<UploadSolution/>}/>
      <Route path='/question/:id' element={<UploadQuestion/>}/>
      <Route path='/compare/:id' element={<CompareQSet/>}/> */}
      <Route path='/view/:id/questions' element={<ViewQuestions/>}/>
      <Route path='/view/:id/print' element={<PrintView/>}/>
    </Routes>
  );
};

export default Task;